import React from "react"

export type MenuSubConsultasNotaFiscalProps = {
    onSelecionadoMenu: () => void;
    onRenderizarItens: () => void
    onRenderizarLotes: () => void
    onRenderizarEntrega: () => void
    onRenderizarFinanceiro: () => void
    onRenderizarExpedicao: () => void
}


export const MenuSubConsultasNotaFiscal = (props: MenuSubConsultasNotaFiscalProps) => {
    return (
        <>
            <h2>Sub-Consultas</h2>

            <ul>
                <li>
                    <a href="#"
                        onClick={() => {
                            props.onRenderizarItens()
                            props.onSelecionadoMenu();
                        }}>
                        Itens
                    </a>
                </li>
                <li>
                    <a href="#"
                        onClick={() => {
                            props.onRenderizarLotes()
                            props.onSelecionadoMenu();
                        }}>
                        Lotes
                    </a>
                </li>
                <li>
                    <a href="#"
                        onClick={() => {
                            props.onRenderizarEntrega()
                            props.onSelecionadoMenu();
                        }}>
                        Entrega
                    </a>
                </li>
                <li>
                    <a href="#"
                        onClick={() => {
                            props.onRenderizarFinanceiro()
                            props.onSelecionadoMenu();
                        }}>
                        Financeiro
                    </a>
                </li>
                <li>
                    <a href="#"
                        onClick={() => {
                            props.onRenderizarExpedicao()
                            props.onSelecionadoMenu();
                        }}>
                        Expedição
                    </a>
                </li>
            </ul>
        </>
    )
}